import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  '& .MSMapWrapper': {
    backgroundColor: theme.palette.background.default,
    color: theme.palette.common.black,
    height: theme.typography.pxToRem(644),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('lg')]: {
      height: theme.typography.pxToRem(366),
    },
  },
  '& .MSTextItem': {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    '& .MSTextItemIcon': {
      fontSize: theme.typography.pxToRem(24),
    },
  },
  '& .MSLocPin': {
    width: theme.typography.pxToRem(50),
    height: theme.typography.pxToRem(55),
    transform: 'translate(-50%, -100%)',
  },

  '& .MSContactTag': {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.palette.secondary.main,
    gap: theme.spacing(1),
    padding: theme.spacing(0.626, 2, 0, 2),
    color: theme.palette.text.primary,
    borderRadius: theme.spacing(20),
    width: 'fit-content',
    '& .MSFlag': {
      width: theme.spacing(3),
      position: 'relative',
      top: theme.spacing(-0.25),
    },
    '& .MSInternationaIcon': {
      position: 'relative',
      top: theme.spacing(-0.35),
    },
  },
  '& .MSFitContent': {
    width: 'fit-content',
  },
}));

export default StyledBox;
